import { Component, Input, OnInit } from '@angular/core';
import * as countryData from 'country-data';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { CallingCountriesResponse } from '../../lead-generation/shared/phone-numbers-dropdown/CountryCallingInfo';
import { Subject } from 'rxjs/Subject';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cc-country-picker',
  templateUrl: './country-picker.component.html',
  styleUrls: ['./country-picker.component.scss']
})
export class CountryPickerComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() tabulatorIndex: number;

  formControl: FormControl = new FormControl();
  countryFilter: FormControl = new FormControl();
  filteredCountries: Observable<CallingCountriesResponse[]>;
  currentCountry: CallingCountriesResponse;

  private _onDestroy = new Subject<void>();
  private countries: CallingCountriesResponse[];

  constructor() {}

  ngOnInit() {
    this.countries = countryData.callingCountries.all;
    this.currentCountry = this.findInitialCountry();
    this.filteredCountries = this.countryFilter.valueChanges.pipe(startWith(''), map(value => this.filter(value)));
    this.countryFilter.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filter(this.countryFilter.value);
    });
  }

  filter(value: string) {
    const filterValue = value.toLowerCase();
    return this.countries.filter(object => object.name.toLowerCase().includes(filterValue));
  }

  onSelectionChanged() {
    this.form.controls[this.controlName].setValue(this.currentCountry.name);
  }

  private findInitialCountry(): CallingCountriesResponse {
    const initialCountryName = this.form.get(this.controlName).value;
    return initialCountryName ? this.countries.find(option => option.name.toLowerCase() === initialCountryName) : null;
  }
}
